module.exports = __webpack_public_path__ + "img/man_3_iocn.1f1abdba.png";